/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const StethoscopeIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="20.5" cy="10.5" r="2" />
      <path d="M4.5,2 C3.396,2 2.5,2.896 2.5,4 L2.5,9 C2.5,11.762 4.738,14 7.5,14 C10.262,14 12.5,11.762 12.5,9 L12.5,4 C12.5,2.896 11.604,2 10.5,2" />
      <path d="M7.5,14 L7.5,21.5 C7.5,22.604 8.396,23.5 9.5,23.5 C10.605,23.5 11.5,22.604 11.5,21.5 L11.5,16.5 C11.5,15.119 12.619,14 14,14 C15.38,14 16.5,15.119 16.5,16.501 L16.5,19.5 C16.5,20.604 17.396,21.5 18.5,21.5 C19.605,21.5 20.5,20.604 20.5,19.5 L20.5,12.5" />
      <path d="M6,2 C6,3.5 4.5,3.5 4.5,3.5 L4.5,0.5 C4.5,0.5 6,0.5 6,2 Z" />
      <path d="M9,2 C9,0.5 10.5,0.5 10.5,0.5 L10.5,3.5 C10.5,3.5 9,3.5 9,2 Z" />
    </g>
  </svg>
);

export default StethoscopeIcon;
